import { ModelPortfolio } from '@/tumeloshared'

export const compareModelPortfolio = (a: ModelPortfolio, b: ModelPortfolio) => {
  const aId: string = a?.externalId ?? ''
  const bId: string = b?.externalId ?? ''
  return aId.localeCompare(bId)
}
